import { Map, List } from "immutable";
import moment from "moment";
import { CaseDocumentRecord, CompanyDocumentRecord } from "records";
import { DOCUMENTS_ACTIONS, INITIATE_CASE_STATE, DOCUMENT_REVIEW_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants/state-status";
import { AssociatesPipeline } from "../../utils/data-pipelines";

const DEFAULT_CHECKLIST_TYPE = new Map({
    "pre-sanction": new Map({}),
    "post-sanction": new Map({})
});

const DEFAULT_DOCUMENTS_MAP = new Map({
    deletedCompanyDocuments : STATE_STATUS.UNFETCHED,
    requestRemarksStatus : STATE_STATUS.UNFETCHED
});

const INITIAL_STATE = new Map({
    allAssociates : Map({}),
    checklist: DEFAULT_CHECKLIST_TYPE,
    case_documents: DEFAULT_DOCUMENTS_MAP,
    company_documents: DEFAULT_DOCUMENTS_MAP,
    uploads: new Map({}),
    documentAttachId: null,
    documentsMasterList: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null
    }),
    companyDocMasterList : new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null
    }),
    associatesList: new Map({}),
    parseDocumentStatus : STATE_STATUS.UNFETCHED,
    caseV2Documents: DEFAULT_DOCUMENTS_MAP
});

export default (
    state = INITIAL_STATE,
    { type: actionType, payload, error }
) => {
    switch (actionType) {
    case INITIATE_CASE_STATE:
        return state
            .setIn(
                ["checklist", "pre-sanction", payload.case_id],
                new Map({
                    status: STATE_STATUS.UNFETCHED,
                    data: null,
                    error: null
                })
            )
            .setIn(
                ["checklist", "post-sanction", payload.case_id],
                new Map({
                    status: STATE_STATUS.UNFETCHED,
                    data: null,
                    error: null
                })
            )
            .setIn(
                ["case_documents", payload.case_id],
                new Map({
                    status: STATE_STATUS.UNFETCHED,
                    data: new Map({}),
                    error: null
                })
            );
    case DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CHECKLIST:
        return state.setIn(
            ["checklist", payload.type, payload.case_id],
            new Map({
                status: STATE_STATUS.FETCHING,
                data: null,
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FETCHED_DOCUMENTS_CHECKLIST:
        return state.setIn(
            ["checklist", payload.type, payload.case_id],
            new Map({
                status: STATE_STATUS.FETCHED,
                data: payload.checklist,
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FAILED_FETCH_DOCUMENTS_CHECKLIST:
        return state.setIn(
            ["checklist", payload.type, payload.case_id],
            new Map({
                status: STATE_STATUS.FETCHED,
                data: null,
                error
            })
        );
    case DOCUMENTS_ACTIONS.FETCH_COMPANY_DOCUMENTS:
        return state.setIn(
            ["company_documents", payload.company_id],
            new Map({
                status: STATE_STATUS.FETCHING,
                data: new Map({}),
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FETCHED_COMPANY_DOCUMENTS:
        return state.setIn(
            ["company_documents", payload.company_id],
            new Map({
                status: STATE_STATUS.FETCHED,
                data: new List(payload.documents)
                    .toMap()
                    .mapEntries(([, v]) => [
                        v.id,
                        new Map({
                            status: STATE_STATUS.FETCHED,
                            data: new CompanyDocumentRecord(v)
                                .set("create_date", moment(v.create_date))
                                .set(
                                    "modified_date",
                                    moment(v.modified_date)
                                )
                        })
                    ]),
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FAILED_FETCH_COMPANY_DOCUMENTS:
        return state.setIn(
            ["company_documents", payload.company_id],
            new Map({
                status: STATE_STATUS.FETCH_FAILED,
                data: new Map({}),
                error
            })
        );

    case DOCUMENTS_ACTIONS.UPLOAD_DOCUMENTS:
        return state.mergeIn(
            ["company_documents", payload.company_id, "data"],
            new List(payload.documents).toMap().mapEntries(([, v]) => [
                v.id,
                new Map({
                    status: STATE_STATUS.FETCHED,
                    data: new CompanyDocumentRecord(v)
                        .set("create_date", moment(v.create_date))
                        .set("modified_date", moment(v.modified_date))
                        .set("is_active", true)
                })
            ])
        );
    case DOCUMENTS_ACTIONS.UPLOADED_DOCUMENT:
        return state.mergeIn(["company_documents", payload.company_id, "data", payload.document.id], new Map({
            status: STATE_STATUS.FETCHED,
            data: new CompanyDocumentRecord(payload.document)
                .set("create_date", moment(payload.document.create_date))
                .set("modified_date", moment(payload.document.modified_date))
        }));
    case DOCUMENTS_ACTIONS.FETCH_CASE_DOCUMENTS:
        return state.setIn(
            ["case_documents", payload.case_id],
            new Map({
                status: STATE_STATUS.FETCHING,
                data: new Map({}),
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FETCHED_CASE_DOCUMENTS:
        var filterNullDocuments = payload.documents.filter(_ => (_.document == 8 ? _.file.document_option  : true))
        return state.setIn(
            ["case_documents", payload.case_id],
            new Map({
                status: STATE_STATUS.FETCHED,
                data: new List(filterNullDocuments)
                    .toMap()
                    .mapEntries(([, v]) => [
                        v.id,
                        new Map({
                            status: STATE_STATUS.FETCHED,
                            data: new CaseDocumentRecord(v)
                                .set("create_date", moment(v.create_date))
                                .set(
                                    "modified_date",
                                    moment(v.modified_date)
                                )
                        })
                    ]),
                error: null
            })
        );
    case DOCUMENTS_ACTIONS.FAILED_FETCH_CASE_DOCUMENTS:
        return state.setIn(
            ["case_documents", payload.case_id],
            new Map({
                status: STATE_STATUS.FETCH_FAILED,
                data: null,
                error
            })
        );
    case DOCUMENTS_ACTIONS.ATTACHED_DOCUMENTS:
        return state
            .setIn(
                [
                    "case_documents",
                    payload.case_id,
                    "data",
                    payload.doc.id,
                    "data"
                ],
                new CaseDocumentRecord(payload.doc)
                    .set("create_date", moment(payload.doc.create_date))
                    .set("modified_date", moment(payload.doc.modified_date))
            )
            .setIn(
                [
                    "case_documents",
                    payload.case_id,
                    "data",
                    payload.doc.id,
                    "status"
                ],
                STATE_STATUS.FETCHED
            );
    case DOCUMENTS_ACTIONS.UPDATE_DOCUMENTS:
        return state
            .setIn(
                [
                    "case_documents",
                    payload.case_id,
                    "data",
                    payload.doc.id,
                    "data"
                ],
                payload.doc
            )
            .setIn(
                [
                    "case_documents",
                    payload.case_id,
                    "data",
                    payload.doc.id,
                    "status"
                ],
                STATE_STATUS.UPDATING
            );
    case DOCUMENTS_ACTIONS.UPDATED_DOCUMENTS:
        return state.deleteIn([
            "case_documents",
            payload.case_id,
            "data",
            payload.docId
        ]);
    case DOCUMENTS_ACTIONS.FAILED_UPDATE_DOCUMENTS:
        return state.setIn(
            [
                "case_documents",
                payload.case_id,
                "data",
                payload.docId,
                "status"
            ],
            STATE_STATUS.UPDATE_FAILED
        );
    case DOCUMENTS_ACTIONS.VALIDATED_DOCUMENT_APPROVAL:
        return state.setIn([
            "company_documents",
            "companyDocStatus"
        ], STATE_STATUS.FETCHED);
    case DOCUMENTS_ACTIONS.FAILED_VALIDATE_DOCUMENT:
        return state.setIn([
            "company_documents",
            "companyDocStatus"
        ], STATE_STATUS.UNFETCHED);
    case DOCUMENTS_ACTIONS.INVALIDATED_DOCUMENT_STATUS:
        return state.setIn([
            "company_documents",
            "deletedCompanyDocuments"
        ], STATE_STATUS.FETCHED);
    case DOCUMENTS_ACTIONS.FAILED_INVALIDATE_DOCUMENT_STATUS:
        return state.setIn([
            "company_documents",
            "deletedCompanyDocuments"
        ], STATE_STATUS.UNFETCHED);
    case DOCUMENTS_ACTIONS.VALIDATED_DOCUMENT:
    case DOCUMENTS_ACTIONS.INVALIDATED_DOCUMENT:
        return state.setIn([
            "company_documents",
            payload.company_id,
            "data",
            payload.file.id,
            "data"
        ],payload.file);
    case DOCUMENT_REVIEW_ACTIONS.ADD_REQUEST_REMARKS :
        return state.setIn(['company_documents','requestRemarksStatus'] , STATE_STATUS.UNFETCHED) 
    case DOCUMENT_REVIEW_ACTIONS.ADDED_REQUEST_REMARKS:
        return state.setIn([
            "company_documents",
            payload.company_id,
            "data",
            payload.file.id,
            "data"
        ],payload.file)
        .setIn(['company_documents','requestRemarksStatus'] , STATE_STATUS.FETCHED);
    case DOCUMENT_REVIEW_ACTIONS.FAILED_ADD_REQUEST_REMARKS : 
        return state.setIn(['company_documents','requestRemarksStatus'] , STATE_STATUS.FETCH_FAILED) 
    case DOCUMENT_REVIEW_ACTIONS.FETCH_DOCUMENT_TYPES:
        return state.setIn([
            "documentsMasterList",
            "status"
        ], STATE_STATUS.FETCHING);
    case DOCUMENT_REVIEW_ACTIONS.FETCHED_DOCUMENT_TYPES:
        if(payload.companyId){
            return state.setIn([
                "companyDocMasterList",
                "status"
            ], STATE_STATUS.FETCHED).setIn([
                "companyDocMasterList",
                "data"
            ],payload.data);
        }else{
            return state.setIn([
                "documentsMasterList",
                "status"
            ], STATE_STATUS.FETCHED).setIn([
                "documentsMasterList",
                "data"
            ],payload.data);
        }
    case DOCUMENT_REVIEW_ACTIONS.FAILED_FETCH_DOCUMENT_TYPES:
        return state.setIn([
            "documentsMasterList",
            "status"
        ],STATE_STATUS.FETCH_FAILED);

    case DOCUMENT_REVIEW_ACTIONS.FETCH_APPLICANTS_LIST:
        return state.setIn([
            "associatesList",
            payload.companyId,
            "status"
        ], STATE_STATUS.FETCHING);
    case DOCUMENT_REVIEW_ACTIONS.FETCHED_APPLICANT_LIST:
        return state.setIn([
            "associatesList",
            payload.companyId,
            "status"
        ], STATE_STATUS.FETCHED)
            .setIn([
                "associatesList", payload.companyId, "data"], payload.data && payload.data.map(_ => ({
                label: _ && ((_.first_name || "") + " " + (_.middle_name || "") + " " + (_.last_name || "")),
                value: _.id
            }))).setIn(['allAssociates' , payload.companyId] , AssociatesPipeline.run(new List(payload.data)));
    case DOCUMENT_REVIEW_ACTIONS.FAILED_FETCH_APPLICANT_LIST:
        return state.setIn([
            "associatesList",
            payload.companyId,
            "status"
        ], STATE_STATUS.FETCH_FAILED);
    case DOCUMENT_REVIEW_ACTIONS.PARSED_DATA:
        // return state.setIn(["parsedData", payload.companyId, payload.documentType, payload.selectedApplicant, payload.selectedDoc], payload.parsedData);
        
        return state
            .set("parseDocumentStatus" , STATE_STATUS.FETCHED)
            .setIn([
                "company_documents",
                payload.document.company || payload.document.document.company,
                "data",
                payload.document.id || payload.document.document.id,
                "data"
            ], payload.document);
    case DOCUMENT_REVIEW_ACTIONS.PARSE_DATA : 
        return state.set("parseDocumentStatus" , STATE_STATUS.FETCHING);  

    case DOCUMENT_REVIEW_ACTIONS.FAILED_PARSE_DATA : 
        return state.set("parseDocumentStatus" , STATE_STATUS.FETCH_FAILED);  

        case DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CASE_V2:
            return state.setIn(
                ["caseV2Documents", payload.company_id],
                new Map({
                    status: STATE_STATUS.FETCHING,
                    data: new Map({}),
                    error: null
                })
            );
        case DOCUMENTS_ACTIONS.FETCHED_DOCUMENTS_CASE_V2:
            return state.setIn(
                ["caseV2Documents", payload.company_id],
                new Map({
                    status: STATE_STATUS.FETCHED,
                    data: new List(payload.documents)
                        .toMap()
                        .mapEntries(([, v]) => [
                            v.id,
                            new Map({
                                status: STATE_STATUS.FETCHED,
                                data: new CompanyDocumentRecord(v)
                                    .set("create_date", moment(v.create_date))
                                    .set(
                                        "modified_date",
                                        moment(v.modified_date)
                                    )
                            })
                        ]),
                    error: null
                })
            );
        case DOCUMENTS_ACTIONS.FAILED_FETCH_DOCUMENTS_CASE_V2:
            return state.setIn(
                ["caseV2Documents", payload.company_id],
                new Map({
                    status: STATE_STATUS.FETCH_FAILED,
                    data: null,
                    error
                })
            );
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
